var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui-accordion" },
    _vm._l(_vm.items, function(item) {
      return _c("ui-accordion-item", {
        key: item.id,
        attrs: { title: item.title, content: item.description }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }